import React from 'react'
import useReactApexChart from '../../hook/useReactApexChart'
import ReactApexChart from 'react-apexcharts'

const UserActivatesTwo = () => {
    let { statisticsDonutChartSeriesThree, statisticsDonutChartOptionsThree } = useReactApexChart();
    
    // console.log("statisticsDonutChartSeriesThree: ", statisticsDonutChartSeriesThree);
    // console.log("statisticsDonutChartOptionsThree: ", statisticsDonutChartOptionsThree);

    // Ensure default data if empty
    const hasData = statisticsDonutChartSeriesThree && statisticsDonutChartSeriesThree.length > 0;
    const chartSeries = hasData ? statisticsDonutChartSeriesThree : [100];
    const chartOptions = hasData
        ? statisticsDonutChartOptionsThree
        : {
            labels: ["No Data"],
            colors: ["#D3D3D3"], // Light grey for empty state
            legend: { show: false },
            dataLabels: { enabled: false }
        };

    // Render dynamic values based on the series length
    const renderDynamicValues = () => {
        return hasData ? statisticsDonutChartSeriesThree.map((value, index) => (
            <span key={index}></span> // Placeholder for dynamic UI
        )) : null;
    };

    // Calculate the sum of the series
    const totalSum = hasData ? statisticsDonutChartSeriesThree.reduce((acc, value) => acc + value, 0) : 0;

    return (
        <div className="col-xxl-3">
            <div className="card h-100 radius-8 border-0">
                <div className="card-body p-24">
                    <h6 className="mb-2 fw-bold text-lg">Ongoing Batch Student Count</h6>
                    <div className="position-relative">
                        {renderDynamicValues()}
                        <ReactApexChart 
                            options={chartOptions} 
                            series={chartSeries} 
                            type="donut" 
                            height={230} 
                            id="statisticsDonutChart"
                            className="mt-36 flex-grow-1 apexcharts-tooltip-z-none title-style circle-none" 
                        />
                    </div>
                    <ul className="d-flex flex-wrap flex-column mt-64 gap-3">
                        <li className="d-flex align-items-center gap-2">
                            <span className="w-16-px h-16-px radius-2 bg-light" />
                            <span className="text-secondary-light text-lg fw-normal">
                                Ongoing Batches:
                                <span className="text-primary-light fw-bold text-lg ms-2">
                                    {hasData ? statisticsDonutChartSeriesThree.length : 0}
                                </span>
                            </span>
                        </li>
                        <li className="d-flex align-items-center gap-2">
                            <span className="w-16-px h-16-px radius-2 bg-light" />
                            <span className="text-secondary-light text-lg fw-normal">
                                Ongoing Batch students:
                                <span className="text-primary-light fw-bold text-lg ms-2">
                                    {totalSum}
                                </span>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default UserActivatesTwo;
